module.exports = __webpack_public_path__ + "img/Lichtdoorlatend.e4de2534.png";